import Accordions from './accordions'
import Scroll from './animations/scroll'
import Heights from './matchHeight'
import Sliders from './sliders'
import Filter from './filters'
import Menu from './menu'
import Tabs from "./tabs"
import Video from "./video"
import Process from "./process"
import jQuery from 'jquery'
import { Maps } from "./map";
import Popup from "./popup";

window.addEventListener('DOMContentLoaded', () => {

	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + (Math.random() * 0xffffff << 0).toString(16)
	// })

	Heights()
	Sliders()
	Filter()
	Menu()
	Video()
	Process()
	Maps()
	Popup()


	new Scroll(
		document.querySelectorAll('[data-fade-in]'),
		{
			opacity: 0,
			top: 20,
			position: 'relative'
		},
		{
			opacity: 1,
			top: 0,
			duration: 1,
		}
	)


	// Default Accordions
	const accordionSections = document.querySelectorAll('[data-accordions]')

	if (accordionSections.length) {
		accordionSections.forEach(accordions => {
			new Accordions(accordions, '[data-accordion]', true)
		})
	}

	// Default Tabs
	const tabs = document.querySelectorAll('[data-tabs]')

	if (tabs.length) {
		tabs.forEach(tab => {
			new Tabs(tab)
		})
	}

	// Search
	const searchTrigger = document.querySelectorAll('.js-search-trigger')
	const search = document.querySelector('.js-search')

	if (searchTrigger) {
		searchTrigger.forEach(trigger => {
			trigger.addEventListener('click', () => {
				search.classList.toggle('active')
				search.querySelector('input').focus();
			})
		});

	}

	// Gated Download
	let gateTrigger = jQuery('.js-gated-download-trigger');
	let gatedDownload = jQuery('.c-gated-download');

	if (gateTrigger.length && gatedDownload.length) {
		jQuery.each(gateTrigger, function (index, element) {
			jQuery(element).on('click', function () {
				gatedDownload.addClass('active');
			});
		});
	}

	// fine iframe in .c-editable and wrap in .e-media.e-media--pizza
	const editable = document.querySelectorAll('.c-editable');
	if (editable.length) {
		editable.forEach(element => {
			const iframe = element.querySelector('iframe');
			if (iframe) {
				const wrapper = document.createElement('div');
				wrapper.classList.add('e-media', 'e-media--video');
				iframe.parentNode.insertBefore(wrapper, iframe);
				wrapper.appendChild(iframe);
			}
		});
	}

})
